export default "__VITE_ASSET__Couz0oJN__"